module.exports = __webpack_public_path__ + "img/suzhou.3e19a143.png";